function useUtils() {
  return {
    calculateTotalCostOfConfiguration: (configuration, baseProduct) => {
      let totalCost = 0;
      if (baseProduct && baseProduct.price) {
        //Start with base product price if provided
        totalCost = baseProduct.price;
      }
      for (let categoryName in configuration) {
        let selectedProducts = configuration[categoryName].selectedProducts;
        const totalCostForCategory = selectedProducts.reduce(
          (previousValue, currentValue) =>
            previousValue + currentValue.price * currentValue.qty,
          0
        );
        totalCost += totalCostForCategory;
      }
      return totalCost;
    },
  };
}
export default useUtils;
